export default {
	code: 'Kood',
	name: 'Nõrkus',
	catalog: 'Kataloog',
	connectedRisks: 'Seotud riske',
	score: 'Riskitase',
	category: 'Kategooria',
	description: 'Kirjeldus',
	addName: 'Lisa nõrkuse nimi',
	addCode: 'Lisa nõrkuse kood',
	addDescription: 'Lisa nõrkuse kirjeldus',
	addVulnerability: 'Lisa uus nõrkus',
}
